import { render, staticRenderFns } from "./TheAdminHeader.vue?vue&type=template&id=50a9913b"
import script from "./TheAdminHeader.vue?vue&type=script&lang=js"
export * from "./TheAdminHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports